import { Node } from 'slate';

export const PARAGRAPH_TOGGLE = 'paragraph-toggle';

export type ParagraphToggleOptions = {
  isReadOnly?: boolean;
  [key: string]: any;
};

export type ParagraphToggle = {
  visible?: boolean;
  label?: string;
  toggle?: boolean;
  placeholder?: string;
  /** metadata that this paragraph present something */
  present?: string;
  children?: Node[];

  /** Required: to tell exact which parent node can customize */
  parentNodeType: string;

  /** Count voids/inline as text */
  includeVoids?: boolean;
};

export type ParagraphToggleNode = ParagraphToggle & Node;
